var components
try {
  components = {
    uniIcons: function () {
      return import(
        /* webpackChunkName: "uni_modules/uni-icons/components/uni-icons/uni-icons" */ "@/uni_modules/uni-icons/components/uni-icons/uni-icons.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  _vm.$initSSP()
  var m0 = _vm.slotSelected ? _vm.getSelectedItems() : null
  var g0 = _vm.showSelector
    ? _vm.slotEmpty && _vm.mixinDatacomResData.length === 0
    : null
  var g1 = _vm.showSelector && !g0 ? _vm.mixinDatacomResData.length : null
  _vm.$initSSP()
  var l0 =
    _vm.showSelector && _vm.slotOption
      ? _vm.__map(_vm.mixinDatacomResData, function (itemData, index) {
          var $orig = _vm.__get_orig(itemData)
          var g2 = _vm.multiple
            ? _vm.getCurrentValues().includes(itemData.value)
            : null
          var m1 = !_vm.multiple ? _vm.getCurrentValues() : null
          if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
            _vm.$setSSP("option", {
              item: $orig,
              itemSelected: _vm.multiple
                ? $orig.__$$global$$__
                : m1 == $orig.value,
            })
          }
          return {
            $orig: $orig,
            g2: g2,
            m1: m1,
          }
        })
      : null
  var l1 =
    _vm.showSelector && !_vm.slotOption
      ? _vm.__map(_vm.mixinDatacomResData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g3 = !_vm.multiple && _vm.mixinDatacomResData.length > 0
          var m2 = g3 ? _vm.formatItemName(item) : null
          return {
            $orig: $orig,
            g3: g3,
            m2: m2,
          }
        })
      : null
  var g4 =
    _vm.showSelector && !_vm.slotOption
      ? _vm.multiple && _vm.mixinDatacomResData.length > 0
      : null
  var l2 =
    _vm.showSelector && !_vm.slotOption && g4
      ? _vm.__map(_vm.mixinDatacomResData, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g5 = _vm.getCurrentValues().includes(item.value)
          var m3 = _vm.formatItemName(item)
          return {
            $orig: $orig,
            g5: g5,
            m3: m3,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        g0: g0,
        g1: g1,
        l0: l0,
        l1: l1,
        g4: g4,
        l2: l2,
      },
    }
  )
  if (_vm.$scope.data.scopedSlotsCompiler === "augmented") {
    _vm.$setSSP("selected", {
      selectedItems: m0,
    })
    _vm.$setSSP("empty", {
      empty: _vm.emptyTips,
    })
  }
  _vm.$callSSP()
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }